import { create } from 'zustand'

interface CardPlacerState {
  isOpen: boolean
  selectedParentLid: string | null
  branchType: 'continue' | 'branch'
  previewLid: string | null
  sectionId: string | null
}

interface UIState {
  cardPlacer: CardPlacerState
  sidebarOpen: boolean
  theme: 'light' | 'dark'
}

interface UIActions {
  // Card placer actions
  openCardPlacer: (sectionId: string) => void
  closeCardPlacer: () => void
  setParentLid: (lid: string | null) => void
  setBranchType: (type: 'continue' | 'branch') => void
  setPreviewLid: (lid: string | null) => void

  // UI actions
  toggleSidebar: () => void
  setSidebarOpen: (open: boolean) => void
  setTheme: (theme: 'light' | 'dark') => void
  toggleTheme: () => void
}

type UIStore = UIState & UIActions

const initialCardPlacerState: CardPlacerState = {
  isOpen: false,
  selectedParentLid: null,
  branchType: 'branch',
  previewLid: null,
  sectionId: null,
}

export const useUIStore = create<UIStore>((set) => ({
  // Initial state
  cardPlacer: initialCardPlacerState,
  sidebarOpen: true,
  theme: 'light',

  // Card placer actions
  openCardPlacer: (sectionId) =>
    set({
      cardPlacer: {
        ...initialCardPlacerState,
        isOpen: true,
        sectionId,
      },
    }),

  closeCardPlacer: () =>
    set({
      cardPlacer: initialCardPlacerState,
    }),

  setParentLid: (lid) =>
    set((state) => ({
      cardPlacer: {
        ...state.cardPlacer,
        selectedParentLid: lid,
      },
    })),

  setBranchType: (type) =>
    set((state) => ({
      cardPlacer: {
        ...state.cardPlacer,
        branchType: type,
      },
    })),

  setPreviewLid: (lid) =>
    set((state) => ({
      cardPlacer: {
        ...state.cardPlacer,
        previewLid: lid,
      },
    })),

  // UI actions
  toggleSidebar: () =>
    set((state) => ({
      sidebarOpen: !state.sidebarOpen,
    })),

  setSidebarOpen: (open) => set({ sidebarOpen: open }),

  setTheme: (theme) => set({ theme }),

  toggleTheme: () =>
    set((state) => ({
      theme: state.theme === 'light' ? 'dark' : 'light',
    })),
}))
